import type SVGType from 'types/svg.types';

const SendMoneyIcon: SVGType = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_9100_29172)">
      <path
        d="M10.3 17.2505H6.75C5.64543 17.2505 4.75 16.3551 4.75 15.2505V8.75049C4.75 7.64592 5.64543 6.75049 6.75 6.75049H17.25C18.3546 6.75049 19.25 7.64592 19.25 8.75049V11.3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 12.0005C13.5 12.8289 12.8284 13.5005 12 13.5005C11.1716 13.5005 10.5 12.8289 10.5 12.0005C10.5 11.1721 11.1716 10.5005 12 10.5005C12.8284 10.5005 13.5 11.1721 13.5 12.0005Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.75 14.7998L19.25 17.0498M19.25 17.0498L16.75 19.2998M19.25 17.0498H13.85"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_9100_29172">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SendMoneyIcon;
